





































import settings from '@/settings.coffee'


export default {
  props:{
      consultant: Object
  }
  computed:
    settings: ()->
      settings
  mounted: ()->
    setTimeout(()->
      new AcornIcons().replace()
      # -- defined in /public/js/scripts
      #scripts = new Scripts();
      return
    ,200)        

}
